import { AccessDenied } from '@gravity-ui/illustrations';
import { Link } from '@gravity-ui/uikit';

import { EMAIL, INVALID_LINK, NEW_LINK, OLD_LINK } from '../../constants';

import styles from './styles.module.scss';

export const InvalidLink = () => {
	return (
		<div className={styles.reg_wrong}>
			<AccessDenied className={styles.reg_wrong__img} />

			<h2>{INVALID_LINK}</h2>

			<div className={styles.reg_wrong__invalid_link}>
				{NEW_LINK}{' '}
				<Link view="normal" href="#">
					{EMAIL}
				</Link>
				, {OLD_LINK}
			</div>
		</div>
	);
};
